import { useTranslation } from "react-i18next";

const cards = [
  { key: "spreadsheet", icon: "ri-table-line", color: "bg-primary-100 text-primary-700" },
  { key: "research", icon: "ri-search-2-line", color: "bg-accent-100 text-accent-700" },
  { key: "sellers", icon: "ri-store-3-line", color: "bg-secondary-100 text-secondary-700" },
  { key: "qc", icon: "ri-shield-check-line", color: "bg-primary-100 text-primary-700" },
  { key: "shipping", icon: "ri-truck-line", color: "bg-accent-100 text-accent-700" },
  { key: "safety", icon: "ri-lock-star-line", color: "bg-secondary-100 text-secondary-700" },
];

export default function ValuePropSection() {
  const { t } = useTranslation();

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            {t("valueProp.h2")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
            {t("valueProp.copy")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {cards.map((card) => (
            <div
              key={card.key}
              className="group p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/60 hover:border-primary-300/50 hover:shadow-md transition-all"
            >
              <div className={`w-10 h-10 md:w-12 md:h-12 rounded-lg ${card.color} flex items-center justify-center mb-4`}>
                <i className={`${card.icon} text-lg md:text-xl`} />
              </div>
              <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg mb-2">
                {t(`valueProp.cards.${card.key}.title`)}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {t(`valueProp.cards.${card.key}.desc`)}
              </p>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors"
          >
            {t("valueProp.cta")}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}